import {ApiClientCommunication} from 'neo-common';
import {IRequest} from './IRequest';

/**
 * @class Request<TResponse> - abstract class for other request classes.
 */
export abstract class Request<TResponse extends ApiClientCommunication.ResponseBase>
    extends ApiClientCommunication.RequestBase<TResponse> implements IRequest {
    /**
     * @property messageId - id of client message
     */
    messageId: number;

    /**
     * @property customData - custom data object
     */
    customData: any;

    /**
     * @property cfgVersion - Last known game configuration version.
     */
    cfgVersion?: number;

    constructor(customData?: any) {
        super();
        this.messageId = this.generateId();
        this.customData = customData;
    }

    private generateId(): number {
        return new Date().getTime();
    }

    /**
     * @method actionName - name of action used when sending request to api server.
     */
    abstract actionName(): string;
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Requests/Request.ts
 **/